import React, { useEffect, useState} from 'react'
import Modal from 'react-modal'
import { renderTextField, renderButton, renderCancelButton} from '@/shared/FormUtils'
import Dropzone from 'react-dropzone'
import classNames from 'classnames'
import { Stack } from '@mui/material'
import Cookies from 'universal-cookie'
import ItemRemovalForm from './ItemRemovalForm'
import { isJaguar } from '@/utility/UserUtils'
import DeleteItemForm from './DeleteItemForm'
import ItemAddForm from './ItemAddForm'
import InventoryChits from '@/items/components/InventoryChits'
const ItemInventoryModal = (props) => {
  const {
    item,
    open,
    onClose,
    onSave,
    formikProps,
    inventoryCount,
    user
  } = props
  const renderInventoryCounts = () => {
    if(!inventoryCount) return
    return (
      <div className="item-form-inventory-chit-container">
        <InventoryChits
          item={item}
          inventoryCount={inventoryCount}
        />
      </div>
    )
  }

  const tabs = [
    {label:"Add To Inventory", value:"add_to_inventory", component: ItemAddForm},
    {label: "Reduce Inventory", value:"reduce_inventory", component: ItemRemovalForm, jaguarOnly: true},
    {label: "Delete Item", value:"delete_item", component: DeleteItemForm, jaguarOnly: true}
  ].filter(tab=> {
    if(tab.jaguarOnly && !isJaguar(props.user)) return false
    return true
  })

  const [activeTab, setActiveTab] = useState(tabs[0].value)
  const renderTabs = () => {
    if(!isJaguar(user)) return
    return(
      <div className=" item-inventory-modal-tabs">
        {tabs.map(tab => (
          <div className={`item-inventory-modal-tab ${activeTab == tab.value ? "item-inventory-modal-tab-active" : "" }`} key={tab.value} onClick={()=>{
            setActiveTab(tab.value)
          }}>
            {tab.label}
          </div>
        ))}
      </div>
    );
  }

  const renderTabContents = () => {
    if(!open) return
    const TabComponent = tabs.find(tab => tab.value == activeTab).component
    if(!TabComponent) return
    return (
      <TabComponent key={`tab-content-${activeTab}`}  {...props}/>
    )
  }

  return (
    <Modal
      className="react-modal add-form-modal add-custom-field-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      onRequestClose={onClose}
      contentLabel="Add An Image"
    >
       <div class="text-emerald-900 text-4xl font-medium font-['Roboto'] pb-4 font-weight-[400]">
        {item.name}
       </div>
       {formikProps.values.item.rental_cost && (
        <div className="w-[521px] h-12 justify-start">
          <span class="text-neutral-500 text-xs font-normal font-['Roboto'] uppercase leading-5 tracking-wide">Rental Price: </span>
          <span class="text-black text-base font-normal font-['Roboto'] leading-5">${parseFloat(formikProps.values.item.rental_cost).toFixed(2)}<br/></span></div>
       )}
      
       {renderInventoryCounts()}

       {renderTabs()}
       {renderTabContents()}
    </Modal>
  )
}

export default ItemInventoryModal
